import React from "react";
import bgImage1 from "../assets/oil-gas-banner.jpg";
import { useState, useEffect } from "react";
function Projects() {
  const [showHeader, setShowHeader] = useState(false);

  useEffect(() => {
    setShowHeader(true);
  }, []);

 

  return (
    <div className="">
      <div className="flex flex-col justify-center items-center h-screen relative">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `url(${bgImage1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <h1
          className={`text-5xl font-poppins font-bold whitespace-nowrap z-10 transition-opacity duration-[3000ms] ${
            showHeader ? "opacity-100" : "opacity-0"
          }`}
        >
          <p className="leading-snug text-secondary">To be the leader,</p>{" "}
          bridge the gap between conventional
          <p className="text-5xl leading-snug font-poppins font-bold whitespace-nowrap z-10">
            and innovative solutions
          </p>
        </h1>

        <p className="font-poppins text-xl">
          Our project consists of... We provides solutions to company such as
          Petronas
        </p>

        <button
          id="download"
          className="z-10 bg-transparent font-poppins font-semibold text-2xl border-2 border-blue-500 text-blue-500 py-6 px-10 mt-6 transition duration-300 ease-in-out hover:bg-blue-500 hover:text-white hover:border-blue-700"
        >
          <a
            href="https://drive.google.com/file/d/1t0cwS5eDZ00LfAuVqTanilY0Z-OktajP/view?usp=sharing"
            target="_blank"
          >
            See More
          </a>
        </button>
      </div>
    </div>
  );
}

export default Projects;
